import Big from 'big.js';
import { TimeEntryApprovalDtoState, PseudoRow, TimeRow } from '../grid3';
// import { ProjectApprovalDataDict, TimeEntryApprovalDto as TimeEntryApproval, ProjectDto as Project } from '../../data';
import { ProjectApprovalData, TimeEntryApprovalDto, ProjectDto } from '../../api/generated/data-contracts';

export const makeApprovalRow = (approval: TimeEntryApprovalDto, name: string): TimeEntryApprovalDtoState => ({
    id: approval.id,
    name,
    ...approval,
    // The grouping is user specific
    parentId: approval.taskId + approval.userId,
    timeEntry: { ...approval.timeEntry, hours: new Big(String(approval.timeEntry.hours)) },
    type: 'approval',
});

const addRowTimeEntries = (row1: PseudoRow | TimeEntryApprovalDtoState, row2: PseudoRow | TimeEntryApprovalDtoState) => {
    return row1.timeEntry.hours.add(row2.timeEntry.hours);
};

// const convertApproval = ({
//     id,
//     approvalState,
//     project,
//     task,
//     timeEntry,
//     user,
//     userPeriodState,
//     activity,
//     originalRate,
//     parentId,
//     rate,
// }: TimeEntryApprovalDto): TimeEntryApproval => {
//     return {
//         id,
//         approvalState,
//         projectId: project.id,
//         taskId: task.id,
//         timeEntry,
//         userId: user.id,
//         userPeriodState,
//         activityId: activity?.id,
//         originalRate,
//         parentId,
//         rate,
//     };
// };

// const convertProject = ({ id, manager, name, projectNumber }: ProjectDto): Project => {
//     return {
//         id,
//         name,
//         managerId: manager.id,
//         projectNumber,
//     };
// };

// const createDataMap = <T extends { id: string }>(data: T[]): Record<string, T> => {
//     return data.reduce((map, dataPoint) => {
//         map[dataPoint.id] = dataPoint;
//         return map;
//     }, {});
// };

// export const convertDataFormat: (data: ProjectApprovalData) => ProjectApprovalDataDict = ({ activities, approvals }) => {
//     return {
//         projects: Object.fromEntries([...new Map(approvals.map(approval => [approval.project.id, convertProject(approval.project)]))]),
//         approvals: Object.fromEntries(approvals.map(approval => [approval.id, convertApproval(approval)] as const)),
//         activities: Object.fromEntries(activities.map(activity => [activity.id, activity])),
//         tasks: Object.fromEntries([...new Map(approvals.map(approval => [approval.task.id, approval.task]))]),
//         users: Object.fromEntries([
//             ...new Map(approvals.map(approval => [approval.user.id, approval.user])),
//             ...new Map(approvals.map(approval => [approval.project.manager.id, approval.project.manager])),
//         ]),
//     } as ProjectApprovalDataDict;
// };

export const buildGridRows = ({ approvals, projects, tasks, users }: ProjectApprovalData) => {
    const rows: TimeRow[] = [];

    const weaveRows = (start: number, ...newRows: TimeRow[]) => {
        rows.splice(start, 0, ...newRows);
        return start + newRows.length - 1;
    };

    const getProjectRowIdx = (approval: TimeEntryApprovalDtoState): number => {
        const existingRowIndex = rows.findIndex(row => row.id === approval.projectId);
        if (existingRowIndex !== -1) {
            const existingRow = rows[existingRowIndex] as PseudoRow;
            existingRow.timeEntry.hours = addRowTimeEntries(existingRow, approval);
            return existingRowIndex;
        }
        const row: PseudoRow = {
            id: approval.projectId,
            name: projects[approval.projectId].name,
            timeEntry: { ...approval.timeEntry },
            pseudoRow: true,
            type: 'project',
            projectId: approval.projectId,
            taskId: approval.taskId,
        };
        rows.push(row);
        return rows.length - 1;
    };

    const getUserRowIdx = (approval: TimeEntryApprovalDtoState, parentIdx: number): number => {
        const parentId = rows[parentIdx].id;
        const existingRowIndex = rows.findIndex(row => row.id === approval.userId + parentId);
        if (existingRowIndex !== -1) {
            const existingRow = rows[existingRowIndex] as PseudoRow;
            existingRow.timeEntry.hours = addRowTimeEntries(existingRow, approval);
            return existingRowIndex;
        }
        const row: PseudoRow = {
            id: approval.userId + parentId,
            name: users[approval.userId].name,
            timeEntry: { ...approval.timeEntry },
            parentId,
            pseudoRow: true,
            type: 'user',
            projectId: approval.projectId,
            taskId: approval.taskId,
        };
        const insertionPoint = parentIdx + 1;
        return weaveRows(insertionPoint, row);
    };

    const getTaskGroupRowIdx = (approval: TimeEntryApprovalDtoState, parentIdx: number) => {
        // Find the user specific row
        const existingRowIndex = rows.findIndex(row => row.id === approval.taskId + approval.userId);
        if (existingRowIndex !== -1) {
            const existingRow = rows[existingRowIndex] as PseudoRow;
            existingRow.timeEntry.hours = addRowTimeEntries(existingRow, approval);
            return existingRowIndex;
        }
        const parentId = rows[parentIdx].id;
        const task = tasks[approval.taskId];
        const row: PseudoRow = {
            // Make the row user specific
            id: approval.taskId + approval.userId,
            name: task.name,
            timeEntry: { ...approval.timeEntry },
            parentId,
            pseudoRow: true,
            type: 'group',
            projectId: approval.projectId,
            taskId: approval.taskId,
        };
        const insertionPoint = parentIdx + 1;
        return weaveRows(insertionPoint, row);
    };

    // Build relations
    Object.values(approvals).forEach(approval => {
        const row = makeApprovalRow(approval, tasks[approval.taskId].name);
        const projectRowIdx = getProjectRowIdx(row);
        const userRowIdx = getUserRowIdx(row, projectRowIdx);
        const taskGroupRowIdx = getTaskGroupRowIdx(row, userRowIdx);
        rows.splice(taskGroupRowIdx + 1, 0, row);
    });

    return rows;
};
